import ImgOffice from 'assets/images/content/frauencoach-office.jpg'
import ImgLemon from 'assets/images/content/persoenliche_balance.jpg'
import {
  Button, Card, CardContent, Col, CollapsibleTopicItem, Container, OfficeMap,
  Row, Section, ShareButtons,
} from 'atoms'
import Image from 'next/image'
import { ContactCard } from 'organisms'
import { FC } from 'react'
import { BsArrowRight, BsCheck2 } from 'react-icons/bs'
import { useShowContactModal } from 'services/ContactModal'

import {
  CollapsibleContentMyWorkflow, CollapsibleContentPossibleTopics,
  CollapsibleContentSecurity, CollapsibleContentWhyPrivate,
} from './CollapsibleContent'
import Styles from './PraxisHPG.module.sass'

const PraxisHPG: FC<unknown> = () => {
  const openContactModal = useShowContactModal()

  return (
    <>
      <Section background="rose">
        <Container>
          <h1>
            Ihre Psychologische Beratung und Therapie in Berlin-Mitte
          </h1>
          <Row className="flex-md-row-reverse">
            <Col xs={12} lg={6} className="mb-5 mb-lg-0">
              <Card>
                <CardContent className="px-4 text-center text-lg-start">
                  <h4>
                    {`Ihre Privatpraxis für psychologische Beratung und Therapie nach Heilpraktikergesetz (HeilprG / HPG)`}
                  </h4>
                  <table className={`${Styles.hpgTable} me-5`}>
                    <tbody>
                      <tr>
                        <td className="td-left td-arrow">
                          <BsArrowRight />
                        </td>
                        <td>
                          <address>
                            Steinstraße 15<br/>
                            10119 Berlin-Mitte<br/>
                            Tel: 0176 20171385
                          </address>
                        </td>
                      </tr>
                      <tr>
                        <td className="td-left td-check">
                          <BsCheck2 />
                        </td>
                        <td>
                          Termin sofort
                        </td>
                      </tr>
                      <tr>
                        <td className="td-left td-check">
                          <BsCheck2 />
                        </td>
                        <td>
                        zentral erreichbar
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <p className="text-center">
                    Wir machen uns gemeinsam auf den Weg.
                    <br/>
                    <strong>Damit es wieder rund läuft.</strong>
                  </p>

                  <Button
                    block
                    theme="blue"
                    className='mt-4'
                    onClick={openContactModal}
                  >
                    Jetzt Kontakt aufnehmen
                  </Button>
                  <span className="text-footnote">
                    Einfach kostenfreies Erstgespräch vereinbaren.
                  </span>
                </CardContent>
              </Card>
            </Col>
            <Col xs={12} lg={6}>
              <Image
                alt="FrauenCoach Praxis / Büro"
                src={ImgOffice}
                placeholder="blur"
              />
            </Col>
          </Row>
        </Container>
      </Section>
      <Section>
        <Container>
          <Row>
            <Col xs={12} lg={6} className="mb-5 mb-lg-3">

              <h4 className="mb-4">
                {`Läuft Ihnen bei diesem Anblick auch das Wasser im Mund zusammen?`}
              </h4>
              <figure className="my-4">
                <Image
                  alt="Gesunde Balance"
                  src={ImgLemon}
                  placeholder="blur"
                  height={600}
                  objectFit="cover"
                />
              </figure>
              <p>
                {`Körper und Geist bilden eine Einheit. Jeder Gedanke ruft immer auch eine körperliche Reaktion hervor. Und so ist das auch, wenn sie etwas psychisch oder emotional belastet. Das zeigt sich körperlich vielleicht in einer verkrampften Muskulatur. Oder der Kopf tut weh, oder oder oder. Jeder kennt seine persönliche Archillesferse am besten.`}
              </p>
              <p>
                <strong>
                  {`Lieber gesund und in persönlicher Balance?`}
                </strong>
              </p>
              <p>
                Dann nehmen Sie gerne Kontakt zu mir auf.
              </p>
              <p>
                <em>
                  Lebensfragen klären<br/>
                  Krisen meistern
                </em>
              </p>

              {/* <Row className="flex-md-row-reverse">
                <Col xs={12} sm={6}>
                  <h4 className="mb-4">
                    {`Läuft Ihnen bei diesem Anblick auch das Wasser im Mund zusammen?`}
                  </h4>
                  <p>
                    {`Körper und Geist bilden eine Einheit. Jeder Gedanke ruft immer auch eine körperliche Reaktion hervor. Und so ist das auch, wenn sie etwas psychisch oder emotional belastet. Das zeigt sich körperlich vielleicht in einer verkrampften Muskulatur. Oder der Kopf tut weh, oder oder oder. Jeder kennt seine persönliche Archillesferse am besten.`}
                  </p>
                </Col>
                <Col xs={12} sm={6}>
                  <figure className="my-4">
                    <Image
                      alt="Gesunde Balance"
                      src={ImgLemon}
                      placeholder="blur"
                    />
                  </figure>
                  <p>
                    <strong>
                      {`Lieber gesund und in persönlicher Balance?`}
                    </strong>
                  </p>
                  <p>
                    Nehmen Sie Kontakt zu mir auf.
                  </p>
                  <p>
                    <em>
                      Lebensfragen klären<br/>
                      Krisen meistern
                    </em>
                  </p>
                </Col>
              </Row> */}
              <Button
                block
                theme="green"
                className='mt-4'
                onClick={openContactModal}
              >
                Kontakt
              </Button>
            </Col>
            <Col xs={12} lg={6}>
              <CollapsibleTopicItem
                groupId="hpg"
                key="whyPrivate"
                id="whyPrivate"
                label="Warum Privatpraxis"
                labelAs="h2"
                content={<CollapsibleContentWhyPrivate />}
              />
              <CollapsibleTopicItem
                groupId="hpg"
                key="myWorkflow"
                id="myWorkflow"
                label="Meine Arbeitsweise"
                labelAs="h2"
                content={<CollapsibleContentMyWorkflow />}
              />
              <CollapsibleTopicItem
                groupId="hpg"
                key="security"
                id="security"
                label="Sicherheit"
                labelAs="h2"
                content={<CollapsibleContentSecurity />}
              />
              <CollapsibleTopicItem
                groupId="hpg"
                key="possibleTopics"
                id="possibleTopics"
                label="Mögliche Themen"
                labelAs="h2"
                content={<CollapsibleContentPossibleTopics />}
              />
            </Col>
          </Row>
        </Container>
      </Section>
      <Section className={Styles.sectionMap}>
        <OfficeMap />
      </Section>
      <Section background="vintage">
        <Container>
          <ContactCard />
        </Container>
      </Section>
      <Section>
        <Container>
          <ShareButtons className="d-none d-md-block" full />
          <ShareButtons className="d-block d-md-none" full size={40} />
        </Container>
      </Section>
    </>
  )
}

export default PraxisHPG
